import { Tree } from "antd";
import * as React from "react";

export interface State {}

export interface Props {
  style?: React.CSSProperties;

  options: any[];
  childrenKey: string;
  valueProp: string;
  titleProp: string;
  keyProp: string;
  noOptionsMsg?: string;
  onChange?: any;
  checkableProp: string;
}

export default class TreeMultiSelect extends React.Component<Props, State> {
  render() {
    const {
      style,
      options,
      childrenKey,
      valueProp,
      titleProp,
      keyProp,
      noOptionsMsg,
      onChange,
      checkableProp
    } = this.props;

    const renderOptions = (options: any[]) => {
      let renderedOptions: any[] = [];

      options.forEach((option: any) => {
        renderedOptions.push({
          key: option[keyProp],
          title: option[titleProp],
          value: option[valueProp],
          checkable: option[checkableProp],
          children: renderOptions(option[childrenKey])
        });
      });
      return renderedOptions;
    };

    return options.length !== 0 ? (
      <Tree
        checkable
        style={style}
        multiple={true}
        treeData={renderOptions(options)}
        onCheck={onChange}
        className={"tree-multi-select-component"}
      />
    ) : (
      <div style={{ textAlign: "center" }}>{noOptionsMsg || ""}</div>
    );
  }
}
